import { useQuery } from '@tanstack/react-query';
import type { Profile } from '@/lib/supabase';
import { useToast } from '@/hooks/use-toast';

export const useProfile = (userId?: string) => {
  const { toast } = useToast();
  
  const {
    data: profile,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['profile', userId],
    queryFn: async () => {
      // Demo profile for development
      const demoProfile: Profile = {
        id: 'demo-id',
        user_id: userId || 'demo-user-id',
        name: "João Silva",
        avatar_url: "https://api.dicebear.com/7.x/avataaars/svg?seed=joao",
        bio: "Goleiro profissional com 5 anos de experiência em ligas amadoras. Especializado em futsal e futebol society.",
        city: "São Paulo",
        experience_level: "advanced",
        rating: 4.8,
        matches_played: 25,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        pending_balance: 6.59
      };
      
      return demoProfile;
    },
    enabled: !!userId,
  });

  return {
    profile,
    isLoading,
    error,
    updateProfile: async () => {
      // Mock update function for demo
      toast({
        title: "Profile updated",
        description: "Your profile has been updated successfully.",
      });
    },
  };
};